<div class="container p-4">
  <app-shared-action-bar [saveReady]="changeOccured && !isSaving" [undoReady]="changeOccured"
    [displayActionSectionBar]="showActionSectionBar" (saveRequest)="validateChanges()"
  (undoRequest)="resetPage()"></app-shared-action-bar>




  <div class="px-4 md:px-8 mt-20">

    <div class="flex justify-between md:w-3/5">
      <h2 class="settings-header">{{ 'audit' | customerTerm }} Users</h2>
      <span
        class="text-center material-symbols-outlined text-xl text-green-700 self-center hover:cursor-pointer mr-1 align-sub"
      (click)="changeDisplayOptions()">settings</span>
    </div>
    @if (!showDisplayOptions && !showUserList) {
      <div>
        <select class="mt-2 mr-4 text-box xl:w-3/5" [(ngModel)]="selectedAuditType"
          [compareWith]="auditTypeComparison" (change)="updateAuditList()">
          @for (a of auditTypeList; track a) {
            <option [ngValue]="a">{{a.Description}}</option>
          }
        </select>
        <select class="mt-2 mr-4 text-box xl:w-3/5" (change)="loadUsers()" [(ngModel)]="selectedAudit"
          [compareWith]="auditComparison">
          @for (a of displayAuditList; track a) {
            <option [disabled]="a.AuditID == -1" [ngValue]="a">
              {{a.AuditName}}
            </option>
          }
        </select>
        <button (click)="selectAudit()" class="btn-primary mt-4">Load</button>
      </div>
    }
    @if (showDisplayOptions) {
      <div class="p-2 border-grey-100 rounded-md border-2 mt-2 md:w-3/5">
        <p class="text-green-400">Display</p>
        <div class="flex flex-col mt-2">
          <div class="flex ">
            <app-simple-toggle [(isChecked)]="displayUsernames"></app-simple-toggle>
            <p class="ml-1">Username</p>
          </div>
          <div class="flex mt-2">
            <app-simple-toggle [(isChecked)]="displayEmails"></app-simple-toggle>
            <p class="ml-1">Email</p>
          </div>
        </div>
      </div>
    }
    @if (usersLoaded && showUserList) {
      <div class="lg:mx-6 mx-4 mt-6">
        <div class="mt-4 flex items-center" >
          <p class="settings-selected-item mr-2">{{selectedAudit.AuditName}} </p><span (click)="showDDL()"
          class="hover:cursor-pointer text-xl material-symbols-outlined">
          edit
        </span>
      </div>
      <div class="mt-2">
        <input placeholder="Name" class="text-box w-full md:w-2/5" type="text" (keyup)="filterListByUser()"
          [(ngModel)]="filterUser" />
        </div>
        <table class="mt-2">
          <tbody>
            <tr class="border-b-offblack border-b-2 mb-2 py-1">
              <td class="font-bold">All</td>
              @if (displayUsernames) {
                <td class=""></td>
              }
              @if (displayEmails) {
                <td></td>
              }
              <td class="flex justify-center py-2 pl-3">
                <app-toggle-switch [(checked)]="allPermissions"
                (checkedChange)="updateAllPermissions()"></app-toggle-switch>
              </td>
            </tr>
            @for (p of filteredUserList; track p; let i = $index) {
              <tr>
                <td>{{p.DisplayName}}</td>
                @if (displayUsernames) {
                  <td class="pl-1">{{p.Username}}</td>
                }
                @if (displayEmails) {
                  <td class="pl-1">{{p.Email}}</td>
                }
                <td class="flex justify-center py-2 pl-3">
                  <app-toggle-switch [(checked)]="p.HasPermission"
                  (checkedChange)="userUpdate(p)"></app-toggle-switch>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</div>
